import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./en.json"; // adjust the path
import es from "./es.json"; // adjust the path

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
  },
  lng: "en", // set language to Spanish
  fallbackLng: "en", // use English if translation is not available
  interpolation: {
    escapeValue: false,
  },
});

// i18n.changeLanguage = (lang) => i18n.changeLanguage(lang);

export default i18n;
